import React from 'react';
import ReactDOM from 'react-dom/client';
import axios from 'axios';
import './config/apiClient';
import './index.css';
import App from './App';
import { Provider } from 'react-redux';
import { store, persistor } from './store/store';
import { PersistGate } from 'redux-persist/integration/react';
import 'bootstrap/dist/css/bootstrap.min.css';
import reportWebVitals from './reportWebVitals';
import { LOGOUT } from './store/constants';

axios.interceptors.response.use(
	(response) => response,
	(error) => {
		const status = error?.response?.status;
		const requestUrl = error?.config?.url || '';
		const shouldIgnore =
			requestUrl.includes('/login') ||
			requestUrl.includes('/sampleToken') ||
			requestUrl.includes('/checkLogin') ||
			requestUrl.includes('/logout');

		if (status === 401 && !shouldIgnore) {
			const state = store.getState();
			const user = state?.user;
			if (user?.login) {
				store.dispatch({ type: LOGOUT });
			}
		}

		return Promise.reject(error);
	}
);

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
	<Provider store={store}>
		<PersistGate loading={null} persistor={persistor}>
			<App />
		</PersistGate>
	</Provider>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
